import { render } from "./TheChart.vue?vue&type=template&id=4c12f345&scoped=true&ts=true"
import script from "./TheChart.vue?vue&type=script&lang=ts"
export * from "./TheChart.vue?vue&type=script&lang=ts"

import "./TheChart.vue?vue&type=style&index=0&id=4c12f345&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c12f345"]])

export default __exports__